import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { getDisplaySentimentLabel } from '../../../utils/readability'
import { isNullOrEmpty } from '../../../utils'

const Sentiment = props => (
  <div className={`sentiment ${props.klass}`}>
    <div className="sentiment-marker-container">
      <div className={'sentiment-marker'}>
        <div className="sentiment-label">
          {isNullOrEmpty(props.sentiment)
            ? props.renderNotAvailable
            : getDisplaySentimentLabel(props.sentiment)}
        </div>
      </div>
    </div>
    <div className="sentiment-score-container">
      <div className="sentiment-score-bar">
        <div className="sentiment-score-bar-value-container">
          <div className="sentiment-score-bar-value" />
        </div>
      </div>
      <div className="label negative">
        <FormattedMessage
          id={'Readability.Sentiment.Negative'}
          defaultMessage={'Negative'}
        />
      </div>
      <div className="label positive">
        <FormattedMessage
          id={'Readability.Sentiment.Positive'}
          defaultMessage={'Positive'}
        />
      </div>
      <div className="readability-label">
        <FormattedMessage
          id={'Readability.Sentiment.Sentiment'}
          defaultMessage={'Sentiment'}
        />
      </div>
    </div>
  </div>
)

Sentiment.propTypes = {
  sentiment: PropTypes.string,
  klass: PropTypes.string.isRequired,
  renderNotAvailable: PropTypes.object.isRequired
}

export default Sentiment



// WEBPACK FOOTER //
// ./src/components/quest/readability/Sentiment.js